import { Heading, Text, Stack, Link, Box } from "@chakra-ui/react";
import { NextCard } from "./NextCard";
import { useEffect } from "react";
import { MdOutlineChevronRight } from "react-icons/md";
import { NavLink as ReachLink } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import { useTranslation } from "react-i18next";

export function NextTrainings(props) {
  const { t, i18n } = useTranslation();

  const fetchNext = async () => {
    const { data } = await axios.get("/api/bookings/next");
    return data;
  };

  const { data: next, refetch } = useQuery("fetchNext", fetchNext, {
    staleTime: 15 * 1000, // 15 segundos
    //cacheTime: 5 * 60 * 1000, // 5 minutos
  });

  useEffect(() => {
    refetch();
  }, [props.refreshNexTrainings, refetch]);

  function getTrainingDate(d) {
    const today = new Date();
    const startDate = new Date(d);
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    const locale = i18n.language?.startsWith("ca")
      ? "ca-ES"
      : i18n.language?.startsWith("en")
        ? "en-GB"
        : "es-ES";

    if (
      startDate.getFullYear() === today.getFullYear() &&
      startDate.getMonth() === today.getMonth() &&
      startDate.getDate() === today.getDate()
    ) {
      return t("nextTrainings.today");
    } else if (
      startDate.getFullYear() === tomorrow.getFullYear() &&
      startDate.getMonth() === tomorrow.getMonth() &&
      startDate.getDate() === tomorrow.getDate()
    ) {
      return t("nextTrainings.tomorrow");
    } else {
      return startDate.toLocaleDateString(locale, {
        //year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    }
  }

  return (
    <>
      {next && next.length !== 0 && (
        <>
          <Box
            pt={"20px"}
            textAlign="justify"
            margin={"auto"}
            maxWidth={"800px"}
          >
            <Heading
              fontFamily={"Oswald"}
              fontWeight={400}
              fontSize={{ base: "4xl", sm: "4xl", md: "5xl" }}
              lineHeight={"110%"}
              color={"gray.800"}
              p={9}
              pt={4}
              pb={7}
              textAlign={"center"}
            >
              {t("nextTrainings.headingPrefix")}
              <Text as={"span"} color={"blue.500"}>
                &nbsp;{t("nextTrainings.headingEmphasis")}
              </Text>
            </Heading>
          </Box>

          <Stack
            spacing={2}
            width={{ base: "100%", sm: "100%", md: "90%" }}
            margin="auto"
            maxW="1000px"
            pb={2}
            mb={-5}
          >
            {next.map((item) => {
              const day = new Date(item.startDate);
              const hours = day.getHours();
              const minutes = day.getMinutes().toString().padStart(2, "0");

              return (
                <NextCard
                  key={item.trainingId}
                  trainingName={item.trainingName}
                  trainingCoach={item.coachName}
                  trainingDate={getTrainingDate(item.startDate)}
                  trainingStart={`${hours}:${minutes}`}
                  trainingClients={item.participants}
                />
              );
            })}

            <Link
              display="flex"
              alignItems="center"
              px={1}
              as={ReachLink}
              to="/activity"
              width="fit-content"
              alignSelf="flex-end"
            >
              {t("common.viewMore")}
              <MdOutlineChevronRight className="icon-padding" />{" "}
            </Link>
          </Stack>
        </>
      )}
    </>
  );
}
